import './SceneInfo.css';

export interface Props {
  notice?: { header: string; body: string };
  info?: string[];
}

export const SceneInfo: React.FC<Props> = (props) => {
  return (
    <div className="sceneinfo-container">
      {props.notice && (
        <div className="sceneinfo-notice-container">
          <span className="sceneinfo-notice-header">{props.notice.header}</span>
          <span className="sceneinfo-notice-text">{props.notice.body}</span>
        </div>
      )}

      {props.info &&
        props.info.map((text) => (
          <div key={text} className="sceneinfo-info-container">
            <span className="sceneinfo-info-text">{text}</span>
          </div>
        ))}

      <div className="sceneinfo-watermark-container">
        <span className="sceneinfo-watermark-text">
          Powered by
          <span className="sceneinfo-watermark-text-orange"> V2i Realtime</span>
        </span>
      </div>
    </div>
  );
};
